<template>
  <li class="mb-8">
    <div class="w-full flex gap-8">
      <NuxtImg
        v-if="imgSrc && !imgSrcHasError"
        :src="imgSrc"
        alt=""
        class="w-28 md:w-40 self-baseline pt-4"
        loading="lazy"
        :provider="imgSrc.includes('cloudfront') ? 'cloudfront' : undefined"
        @error="onError"
      />
      <NuxtImg
        v-else-if="!imgSrc || imgSrcHasError"
        src="/images/product_related/product_placeholder.svg"
        alt=""
        class="w-28 md:w-40 self-baseline"
        width="40"
        loading="lazy"
        provider="cloudfront"
      />

      <div class="flex w-full justify-between">
        <div>
          <p>{{ name }}</p>
          <p>
            <span
              v-if="
                regaularDataAllowence &&
                regaularDataAllowence * 2 == dataAllowence
              "
              class="strike-through text-text-secondary"
              aria-hidden="true"
              >{{ regaularDataAllowence }}</span
            >
            {{ dataAllowence }} GB
          </p>
        </div>
        <div
          v-if="productPageStore.ui.loading.isFamilySummaryTableLoading"
          class="text-end flex flex-col items-end motion-safe:animate-pulse motion-reduce:animate-none"
        >
          <span class="w-95 h-22 mb-2 bg-text-disabled block"></span>
          <span class="w-65 h-22 mb-2 bg-text-disabled block"></span>
        </div>
        <div v-else class="text-end">
          <p
            class="heading-xxs"
            :aria-label="
              !!regularPrice
                ? `Ordinarie ${regularPrice} ${bindPeriod === 1 ? 'kr' : 'kr/mån'}, nu ${price} ${bindPeriod === 1 ? 'kr' : 'kr/mån'}`
                : `${price} ${bindPeriod === 1 ? 'kr' : 'kr/mån'}`
            "
          >
            <span class="strike-through text-text-secondary" aria-hidden="true">
              {{ regularPrice }}
            </span>

            {{ price }}
            kr/mån
          </p>
          <p v-if="bindPeriod > 0">i {{ bindPeriod }} mån</p>
          <p v-if="offerValidityInMonths">
            Rabatten gäller i {{ offerValidityInMonths }} månader
          </p>
        </div>
      </div>
    </div>
  </li>
</template>

<script lang="ts" setup>
const productPageStore = useMyProductPageStore();

interface Props {
  name: string;
  regularPrice?: number | undefined;
  imgSrc?: string;
  price: number | undefined;
  bindPeriod: number;
  offerValidityInMonths?: number;
  number?: number;
  dataAllowence?: number;
  regaularDataAllowence?: number;
}

const props = defineProps<Props>();

const imgSrcHasError: Ref<boolean> = ref(false);

function onError() {
  imgSrcHasError.value = true;
}

watch(
  () => props.imgSrc,
  () => {
    imgSrcHasError.value = false;
  },
);
</script>

<style lang="scss" scoped></style>
